import React from "react";

const IconNewArrow = ({ item }) => {
  let color;
  if (item === "discover") {
    color = "#22A2B8"; 
  }
  if (item === "pilot") {
    color = "#D565E0";
  }
  if (item === "launch") {
    color = "#31A76F";
  }
  if (item === "boost") {
    color = "#F06C00";
  }

  return (
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="70" height="70" rx="35" stroke={color || "#191B36"} strokeWidth="2" />
      <path d="M38.75 33.5L43.75 38.5L38.75 43.5" stroke={color || "#191B36"} strokeWidth="2" strokeLinecap="square" />
      <path d="M28.25 28.5V32.5C28.25 35.8137 30.9363 38.5 34.25 38.5H43.75" stroke={color || "#191B36"} strokeWidth="2" />
    </svg>
  );
}

export default IconNewArrow;
